module.exports = __webpack_public_path__ + "static/media/password-generator.fea15cac.JPG";